// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import { lmsPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt

export default {
  getSuccessfulEndBeneficiariesList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/EndBeneficiary/v1/EndBeneficiarySearch',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateEndBeneficiariesAction: async (context, formData) => {
    try {
      useJwt.setPermission(lmsPermissions.MODIFY_END_BENEFICIARY_UPLOAD)
      const response = await axiosIns.put('/accounting/api/EndBeneficiary/v1/EndBeneficiaryUpdateRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createEndBeneficiariesAction: async (context, formData) => {
    try {
      useJwt.setPermission(lmsPermissions.BATCH_END_BENEFICIARY_UPLOAD)
      const response = await axiosIns.post('/accounting/api/EndBeneficiary/v1/EndBeneficiaryBatchRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateEndBeneficiariesAction: async (context, formData) => {
    try {
      useJwt.setPermission(lmsPermissions.BATCH_END_BENEFICIARY_UPLOAD)
      const response = await axiosIns.post('/accounting/api/EndBeneficiary/v1/EndBeneficiaryValidateRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFailedEndBeneficiariesList: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/EndBeneficiary/v1/EndBeneficiarySearchRequest',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
